import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BinderAssembliesService } from '../app/binder-assemblies.service';
import { CatalogService } from './catalog.service';

export enum SearchMode {
  LIST = 'list',
  ALL = 'all',
  BANKS = 'banks',
  BINDER = 'binder'
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
    private BASE_URL = environment.landmark_API_URL + '/search';
    private http = inject(HttpClient);
    private binderAssembliesService = inject(BinderAssembliesService);
    private catalogService = inject(CatalogService);

    searchMode = signal(SearchMode.ALL);

    assemblySearchResults = this.binderAssembliesService.searchedAssemblies;
    catalogSearchResults = this.catalogService.filteredCatalogAssemblies;


    // search(query: string) {
    //     return this.http.get(`${this.BASE_URL}/text?q=${query}`);
    // }

    assemblySearch(query: string) {
        this.binderAssembliesService.searchAssemblies(query);
        
    }

    get searchPlaceholder() {
      switch (this.searchMode()) {
        case SearchMode.BANKS:
          return 'Search lenders & draws';
        case SearchMode.LIST:
          return 'Search this list';
        case SearchMode.ALL:
          return 'Search landmark';
        case SearchMode.BINDER:
          return 'Search this binder';
      }
    }

    setSearchMode(mode: SearchMode) {
        this.searchMode.set(mode);
    }
}